import { QueryParamListBase } from '@shared/models';

export interface FetchStudiesListQueryParam extends QueryParamListBase {
  id: number;
  study_date: Date;
  studyTypeName: string;
  InstitutionName: string;
  medicName: string;
  patient: string; 
}


